import React from "react";

export const FCMHeader = () => {
  return (
    <div className="headingWithImg u-mx-auto">
      <h2 className="heading--secondary">
        Miniportal de trámites de la Federación Canófila Mexicana
      </h2>
      <img
        className="headingWithImg_img"
        src="assets/imgs/mainPage/services/pedig.jpg"
        alt="Trámites FCM"
      />
    </div>
  );
};
